import { Pipe, PipeTransform } from '@angular/core';
import { StoreViewModel } from '@models/api.models';

@Pipe({
    name: 'toHtmlPopupProp',
    standalone: true
})
export class ToHtmlPopupPropPipe implements PipeTransform {
    transform(
        value: StoreViewModel[],
        toStoreText: string,
        fallbackImageSrc: string = ''
    ): (StoreViewModel & { html?: string })[] {
        return value.map(store => ({
            ...store,
            html: this.markup(
                store,
                toStoreText,
                store.storePhotos?.[0]?.src ? store.storePhotos?.[0]?.src : fallbackImageSrc
            )
        }));
    }

    private markup(store: StoreViewModel, toStoreText?: string, storeImage?: string): string {
        return `
         ${this.shouldRender(`<img src="${storeImage}" />`, Boolean(storeImage))}
            <address class="address-content">
                <strong>${store.storeName}</strong>
                <div>${store.address}</div>
                <div>${store.postalCode} ${store.city}</div>
                <div>${store.phone}</div>
            </address>
            ${this.shouldRender(
                `<div class="content">
                    <a href="${store.storeUrl}" class="kk-btn kk-btn_rounded kk-btn_blue">${toStoreText}</a>
                 </div>`,
                Boolean(store.storeUrl && toStoreText)
            )}
                `;
    }

    private shouldRender(markup: string, condition: boolean) {
        return condition ? markup : '';
    }
}
